import React from 'react';
import { TITLE, DETAIL_ONE, DETAIL_TWO, DETAIL_THREE, DETAIL_FOUR, DETAIL_FIVE, DETAIL_SIX } from "../constant/privacyAndPolicy";
import { useSelector } from 'react-redux';
import { IReduxStateData } from '../interfaces/redux';

export default function PrivacyAndPolicy() {
    const globalState = useSelector((state: IReduxStateData) => state);
    return (
        <div className="container pt-5 pb-5">
            <div dangerouslySetInnerHTML={{ __html: TITLE[globalState?.selectedLang || ""] }} />

            <div dangerouslySetInnerHTML={{ __html: DETAIL_ONE[globalState?.selectedLang || ""] }} />

            <div dangerouslySetInnerHTML={{ __html: DETAIL_TWO[globalState?.selectedLang || ""] }} />

            <div dangerouslySetInnerHTML={{ __html: DETAIL_THREE[globalState?.selectedLang || ""] }} />

            <div dangerouslySetInnerHTML={{ __html: DETAIL_FOUR[globalState?.selectedLang || ""] }} />

            <div dangerouslySetInnerHTML={{ __html: DETAIL_FIVE[globalState?.selectedLang || ""] }} />

            <div dangerouslySetInnerHTML={{ __html: DETAIL_SIX[globalState?.selectedLang || ""] }} />
        </div>
    )
}
